import { jsxs as I, jsx as t } from "react/jsx-runtime";
import { InputGroup as f, InputLeftAddon as s, InputLeftElement as l, Input as h, InputRightElement as a, InputRightAddon as x } from "@chakra-ui/react";
import R from "react";
import { getVisualStateStyle as j } from "./helper.js";
const y = R.forwardRef(
  ({
    size: u = "md",
    visualState: n,
    leftAddon: r,
    rightAddon: o,
    leftElement: p,
    rightElement: e,
    variant: i = "outline",
    ...d
  }, m) => {
    const c = n ? j(n) : void 0;
    return /* @__PURE__ */ I(f, { size: u, children: [
      r && /* @__PURE__ */ t(s, { children: r }),
      p && /* @__PURE__ */ t(l, { children: p }),
      /* @__PURE__ */ t(h, { ref: m, sx: c, ...d, variant: i }),
      e && /* @__PURE__ */ t(a, { children: e }),
      o && /* @__PURE__ */ t(x, { children: o })
    ] });
  }
);
export {
  y as Input
};
